import React from "react";

export default function Blogs() {
  return (
    <div className="w-full px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Career Blogs & Resources</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden hover:shadow-md transition">
            <div className="h-48 bg-gray-100"></div>
            <div className="p-6">
              <div className="flex gap-2 mb-3">
                <span className="text-[10px] font-bold uppercase tracking-wider text-[#2557a7] bg-blue-50 px-2 py-0.5 rounded">Career Advice</span>
                <span className="text-[10px] font-bold text-gray-400">5 min read</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 leading-tight">
                How to Crack Your Next Tech Interview in 2026
              </h3>
              <p className="text-sm text-gray-500 mb-4 line-clamp-2">
                Learn the top tips and strategies from industry experts to ace your upcoming technical interviews...
              </p>
              <button className="text-sm font-bold text-[#2557a7] hover:underline">
                Read More →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
